export default __webpack_public_path__ + "f69d751db31c025b6a9cc1596ea918c5.png";